import axios from 'axios';
import moment from 'moment-timezone';
const vsprintf = require('sprintf-js').vsprintf;

const cartoAxios = axios.create({
    baseURL: process.env.VUE_APP_CARTO_ROOT
  });

const agoAxios = axios.create({
    baseURL: 'https://services.arcgis.com/fLeGjb7u4uXqeF9q/ArcGIS/rest/services/'
  });

const aisAxios = axios.create({
    baseURL: process.env.VUE_APP_AIS_ROOT ,
});


const zbaFilterTypes = {
    types: {
        RB_ZBA: {
        id: 'RB_ZBA',
        text: 'ZBA',
        description: 'Zoning Board of Adjustment',
        },
        'Zoning Board of Adjustment': {
        id: 'Zoning Board of Adjustment',
        text: 'ZBA',
        description: 'Zoning Board of Adjustment',
        },
    }
}
const applicationtypeFilterTypes = {
    types: {
        // RB_ZBA: {
        // id: 'RB_ZBA',
        // text: 'ZBA',
        // description: 'Zoning Board of Adjustment',
        // },
        // 'Zoning Board of Adjustment': {
        // id: 'Zoning Board of Adjustment',
        // text: 'ZBA',
        // description: 'Zoning Board of Adjustment',
        // },
        RB_BBS: {
          id: 'RB_BBS',
          text: 'BBS',
          description: 'Board of Building Standards'
        },
        RB_LIRB: {
            id: 'RB_LIRB',
            text: 'LIRB',
            description: "'L&I Review Board'"
        },
        'L&I Review Board Codes': {
            id: 'L&I Review Board Codes',
            text: 'LIRB',
            description: 'L&I Review Board'
        },
        'Board of Building Standards': {
          id: 'RB_BBS',
          text: 'BBS',
          description: 'Board of Building Standards'
        },
        'Plumbing Advisory Board': {
          id: 'Plumbing Advisory Board',
          text: 'Plumbing Advisory Board',
          description: 'Plumbing Advisory Board'
        },
        'L&I Review Board Other': {
          id: 'L&I Review Board Other:',
          text: 'LIRB',
          description: 'L&I Review Board Other'
        },
        'Board of Safety and Fire Prevention': {
          id: 'Board of Safety and Fire Prevention',
          text: 'Board of Safety and Fire Prevention',
          description: 'Board of Safety and Fire Prevention'
        },
    }
}

const zbaFilters = Object.keys(zbaFilterTypes.types).join("','");
const applicationtypeFilters = Object.keys(applicationtypeFilterTypes.types).join("','");
const DATES_TYPES_LIST = function(zbaVar) {
    let filters = zbaVar ? zbaFilters : applicationtypeFilters;
    return `SELECT DISTINCT TO_CHAR(scheduleddate, 'MM/DD/YYYY') as field_date, applicationtype FROM APPEALS WHERE applicationtype IN ('${filters}') ORDER BY field_date ASC`;
}
const BASE_APPEALS_LIST = function(zbaVar) {
    let filters = zbaVar ? zbaFilters : applicationtypeFilters;
    return `SELECT *, st_astext(the_geom) AS latlng FROM APPEALS WHERE applicationtype IN ('${filters}') AND DATE(scheduleddate) >= '%s' AND DATE(scheduleddate) < '%s'`;
}
const appealsByDateAndRegion = function(zbaVar) {
    return `${BASE_APPEALS_LIST(zbaVar)} AND ST_intersects(st_transform(the_geom,2272),st_geomfromgeojson('{"type":"Polygon","coordinates":%s,"crs":{"type":"name","properties":{"name":"EPSG:2272"}}}'))`;
}
const CD_URL = 'Council_Districts_2016/FeatureServer/0/query';
const PD_URL = 'Planning_Districts/FeatureServer/0/query';
const RCO_URL = 'Zoning_RCO/FeatureServer/0/query';
const courtHistory = 'SELECT * FROM court_appeals WHERE appealnumber = \'%s\' ORDER BY courtactiondate DESC';
const decisionHistory = 'SELECT * FROM board_decisions WHERE appealnumber = \'%s\' ORDER BY decisiondate DESC';


const rcoParams = {
    where: '1=1',
    outFields: 'ORGANIZATION_NAME',
    returnGeometry: false,
    returnIdsOnly: false,
    returnCountOnly: false,
    orderByFields: 'ORGANIZATION_NAME',
    returnZ: false,
    returnM: false,
    returnDistinctValues: false,
    f: 'pjson',
  };


const gisCommonData = {
    geometryType: 'esriGeometryPolygon',
    spatialRel: 'esriSpatialRelIntersects',
    returnGeometry: true,
    outSR: '2272',
    f: 'pjson',
  };


const allAppealsQuery = function(start, end, zbaVar) {
    // console.log("allAppealsQuery: ", start, end)
    let queryString = replace(BASE_APPEALS_LIST(zbaVar), start, end);
    return `${queryString} ORDER BY scheduleddate ASC`;
}

const replace = function (...args) {
if (!args || args.length === 0) {
    return '';
}
const a = Array.from(args);
const q = a.shift();
return vsprintf(q, a);
}

const councilDistrictGeo = 'DISTRICT=\'%s\'';
const planningDistrictGeo = 'DIST_NAME=\'%s\'';
const rcoGeo = 'ORGANIZATION_NAME=\'%s\'';


const state = () => ({
    appealsTable: [],
    calendarDots: [],
    geographyData: null,
    decisionHistory: null,
    courtHistory: null,
    rcos: [],
    zba: false,
});

// const getters = {

// };  

const mutations = {
    setCalendarDots(state, data) {
        console.log("Setting dots: ", data)
        return state.calendarDots = data;
    },
    setAppealsTable(state, data) {
        // console.log("setAppealsTable");
        let appealsTableArray = [];
        data.map(
          a => {
            let appealsRecord = new Object();
            appealsRecord.date = moment(a.scheduleddate).isValid() ? a.scheduleddate : "Not Available";
            console.log("SCHEDULE DATE TIME:", a.scheduleddate)
            const tempDate = moment(a.scheduleddate);
            tempDate.format('HH:mm:ss') === '00:00:00' ? appealsRecord.time = '-' : appealsRecord.time = tempDate.format('hh:mm A');
            appealsRecord.address = a.address;
            appealsRecord.unit_type = a.unit_type;  
            appealsRecord.unit_num = a.unit_num;
            appealsRecord.zip = a.zip;
            appealsRecord.opa_account_num = a.opa_account_num;
            appealsRecord.parcel_id_num = a.parcel_id_num;
            appealsRecord.censustract = a.censustract;
            appealsRecord.opa_owner = a.opa_owner;
            // console.log(a.completeddate, moment(a.completeddate, moment.ISO_8601).format('D-M-YYYY'))
            appealsRecord.createddate = a.createddate;
            appealsRecord.completeddate = a.completeddate;
            appealsRecord.completeddate = a.completeddate;
            appealsRecord.relatedpermit = a.relatedpermit;
            appealsRecord.relatedcasefile = a.relatedcasefile;
            appealsRecord.appealstatus = a.appealstatus;
            appealsRecord.agendadescription = a.agendadescription;
            appealsRecord.meetingresult = a.meetingresult;
            appealsRecord.decisiondate = a.decisiondate;
            appealsRecord.systemofrecord = a.systemofrecord;

            appealsRecord.primaryappellant = a.primaryappellant;
            appealsRecord.applicationtype = a.applicationtype;
            appealsRecord.appealnumber = a.appealnumber;
            appealsRecord.acceleratedappeal = a.acceleratedappeal;
            appealsRecord.council_district = a.council_district;

            appealsRecord.meetingnumber = a.meetingnumber;
            appealsRecord.appealtype = a.appealtype;
            appealsRecord.primaryappellant = a.primaryappellant;
            appealsRecord.latlng = a.latlng;

            // console.log("decision: ", a.decision, moment(a.scheduleddate).isBefore(moment()) )
            appealsRecord.decision = a.decision ? a.decision : moment(a.scheduleddate, "M-D-YYYY").isBefore(moment()) ? "Pending" : "Scheduled";
            appealsRecord.appealgrounds = a.appealgrounds;
            appealsRecord.coordinatingrco = a.coordinatingrco;

            appealsTableArray.push(appealsRecord);
          }
        )
        return state.appealsTable = appealsTableArray;
    },
    setGeographyData(state, data) {
        return state.geographyData = data.data;
    },
    setDecisions(state, data) {
        console.log("setting decisions: ", data);
        return state.decisionHistory = data;
    },
    setCourtHistory(state, data) {
        return state.courtHistory = data;
    },
    setRcos(state, data) {
        // console.log("rcos: ", data);
        let rcoArray = [];
        data.map( a => rcoArray.push(a.attributes.ORGANIZATION_NAME))
        return state.rcos = rcoArray;
    },
    zbaCalendar(state) {
        // console.log("rcos: ", data);
        return state.zba = true;
    }
};  

const actions = {
    async getDecisions({commit, dispatch}, payload){
        let decisionQuery = replace(decisionHistory, payload.appealnumber);
        // console.log("get decisions", payload.appealnumber,  decisionQuery);
        dispatch
        try {
            let response = await cartoAxios.get('/', {params: {q: decisionQuery}});
            commit("setDecisions", response.data.rows);
        } catch (err) {
            // this.displayModal("getting the RCO data (CODE 006)", err);
        }
        return
    },
    async getHistory({commit, dispatch}, payload){
        let courtQuery = replace(courtHistory, payload.appealnumber);
        // console.log("get history", payload.appealnumber, courtQuery);
        dispatch
        try {
            let response = await cartoAxios.get('/',{params: {q:courtQuery}});
            commit("setCourtHistory", response.data.rows);
        } catch (err) {
            // this.displayModal("getting the RCO data (CODE 006)", err);
             throw new Error(err)
        } finally {
            await dispatch('getDecisions', payload);
        }
        return
    },
    async getRCOs({commit, dispatch}){
        // console.log("getRCOs");
        dispatch
        try {
            let response = await agoAxios.get(RCO_URL, {params: rcoParams});
            if (response.data.features.length > 0) {
              commit("setRcos", response.data.features);
            }
        } catch (err) {
            // this.displayModal("getting the RCO data (CODE 006)", err);
        }
        return
    },
    async getCalendarDots( { state, commit, dispatch }) {
        // console.log('getAppealsTable: ', payload.start, moment(payload.start).format())
        dispatch
        try {
            await cartoAxios.get('/',{ params: {q: DATES_TYPES_LIST(state.zba) }}).then( async response => {
                // console.log("response!!!!: ", response);
                 await commit('setCalendarDots', response.data.rows )
            })
        } catch (err) {
            throw new Error(err)
        } 
        // console.log("finished calendar dots");
        return
    },
    async getAppealsTable( { state, commit, dispatch }, payload) {
        // console.log('getAppealsTable: ', payload.start, moment(payload.start, "M-D-YYYY").format('M-D-YYYY'))
        dispatch
        try {
            let response = await cartoAxios.get('/',{ params: {q: allAppealsQuery(moment(payload.start, "YYYY-MM-DD").format(), moment(payload.end, "YYYY-MM-DD").format(), state.zba) }});
            // console.log("response: ", response);
            await commit('setAppealsTable', response.data.rows );
        } catch (err) {
            throw new Error(err)
        }  finally {
            if (state.geographyData) {
                payload.geometry = state.geographyData.features[0].geometry.rings
                dispatch('getCartoSpatialQuery', payload);
            }
        }
        // console.log("get appeals table finished")
        return
    },
    async getCartoSpatialQuery({ state, commit, dispatch }, payload){
        console.log(payload);
        let zbaVar = state.zba;
        dispatch
        try {
            const cartoResponse = await cartoAxios.post('/',
            {
                q: replace(appealsByDateAndRegion(zbaVar),
                `${moment(payload.dateRange.start, "YYYY-MM-DD").format("M-D-YYYY")}`,
                `${moment(payload.dateRange.end, "YYYY-MM-DD").format("M-D-YYYY")}`,
                JSON.stringify(payload.geometry)
                )
            }
            );
            let dataRows = cartoResponse.data.rows;
            // console.log("carto response from geo query: ", dataRows);
            // let filterDataCollection = objects.getFilterResultsCollection(
            // dataRows
            // );
            commit("setAppealsTable",dataRows);
            return;
        } catch (e) { 
            console.warn(e)
        }
        return
    },
    async getGeographyData({ commit, dispatch }, payload) {
        // console.log("getGeographyData: ", payload)

        let paramType = payload.region === 'cd' ? councilDistrictGeo : payload.region === 'planning' ? planningDistrictGeo : payload.region === 'rco' ? rcoGeo : false;
        let paramURL = payload.region === 'cd' ? CD_URL : payload.region === 'planning' ? PD_URL : payload.region === 'rco' ? RCO_URL : false;

        gisCommonData.where = replace(paramType, payload.id);

        if(paramURL) {
            await agoAxios.get(paramURL, {params: gisCommonData}).then(
                async response => {
                    if (!response.data.error) {
                        const geometry = response.data.features[0].geometry.rings;
                        payload.geometry = geometry;
                        // console.log("payload: ", payload, JSON.stringify( geometry));
                        commit("setGeographyData", geometry);
                        await dispatch("getCartoSpatialQuery", payload );
                        return
                    }
                }
            ).catch(err => {
                console.log(err);
            })  
        } else {
            await dispatch("getAppealsTable", payload );
            return
        }
        return 
    },
    async getAddress( { dispatch }, payload ) {
        dispatch
        try {
          // console.log("this.aisAxios: ", aisAxios);
            let response = await aisAxios.get(`/${encodeURIComponent(payload)}`);
            // console.log("Axios Results: ", response);
            return response
        } catch (err) {
            return false
        }
      },   
};

export default {
    namespaced: true,
    state,
    // getters,
    mutations,
    actions,
  };